import {ObjectIdentifier} from "./object-identifier";

export class ObjectIdentifierWithId extends ObjectIdentifier {

    constructor(public objectTypeId: number, public override objectType: string, public override objectId: number) {
        super(objectType, objectId);
    }
}
